<template>
    <div>
      <div class="p-6 pb-0">
        <BreadCrumbs :navigation="navigation" />
        <div class="flex items-center gap-4 pt-6">
          <VueDatePicker 
          v-model="dateRange"
          range
          locale="it"
          format="dd/MM/yyyy"
          auto-apply
          placeholder="Seleziona intervallo date"
          :enable-time-picker="false"
          class="border rounded-md"
          text-input
          @input="pageDateInputRange"
        ></VueDatePicker>
          <a :href="exportUrl" class="bg-green-600 text-white px-4 py-2 rounded-md shadow-md whitespace-nowrap">Esporta Excel</a>
        </div>
      </div>
      <div class="p-6 pb-0">
        <PageServerTable
          :headers="headers"
          :items="visitors"
          :items-per-page.sync="ipp"
          :items-per-page-options="ippo"
          :sort-by="sortby"
          :items-length="visitorsCount"
          :reload-fn="reload"
          :item-value="'id'"
          :page="page"
          show-current-page
        >
          <template #item.visitor_name="{ item }">
            <span>{{ item.visitor.name }}</span>
          </template>
          <template #item.visitor_company="{ item }">
            <span>{{ item.visitor.company }}</span>
          </template>
          <template #item.contact="{ item }">
            <span>{{ item.contact?.name ?? '-' }}</span>
          </template>
          <template #item.check_in="{ item }">
            <span>{{ formatDateTime(item.check_in) }}</span>
          </template>
          <template #item.check_out="{ item }">
            <span>{{ (item.check_out) ? formatDateTime(item.check_out) : '-' }}</span>
          </template>
        </PageServerTable>
      </div>
    </div>
  </template>
  
  <script>
  import { Link, useForm, router } from '@inertiajs/vue3';
  import BreadCrumbs from '@/Components/BreadCrumbs.vue';
  import Datepicker from 'vue3-datepicker';
  import PageServerTable from '@/Components/PageServerTable.vue';
  import { format, parseISO } from 'date-fns';
  
  export default {
    props: ['visitors', 'visitorsCount'],
    components: {
      Link,
      BreadCrumbs,
      Datepicker,
      PageServerTable
    },
    data() {
      return {
        dateRange: null,
        headers: [],
        sortby: [],
        ipp: 5,
        ippo: [
          { value: 5, title: '5' },
          { value: 10, title: '10' },
          { value: 25, title: '25' },
          { value: 50, title: '50' }
        ],
        page: 1,
        navigation: [
          { name: 'Dashboard', href: route('dashboard') },
          { name: this.$t('modules.reception-digitale'), href: route('modules.home', 'reception-digitale') },
          { name: 'Report visite', href: route('modules.rd-report') }
        ],
        dateFormat: 'dd/MM/yyyy',
      };
    },
    computed: {
      exportUrl() {
        const params = new URLSearchParams();
        if (this.dateRange && this.dateRange[0] && this.dateRange[1]) {
          params.append('dateRange[start]', format(this.dateRange[0], 'yyyy-MM-dd'));
          params.append('dateRange[end]', format(this.dateRange[1], 'yyyy-MM-dd'));
        }
        const qs = params.toString();
        return route('modules.rd-report-export') + (qs ? '?' + qs : '');
      }
    },
    watch: {
      dateRange: {
        handler(newValue) {
          clearTimeout(this.dateRangeTimeout);
          this.dateRangeTimeout = setTimeout(() => {
            this.page = 1;
            this.reload();
          }, 250);
        },
        deep: true
      }
    },
    mounted() {
      this.headers = this.$attrs.headers;
      this.sortby = this.$attrs.sortby;
      this.ipp = this.$attrs.ipp;
      this.page = this.$attrs.page;
      this.dateRange = this.$attrs.dateRange ? [
        new Date(this.$attrs.dateRange.start),
        new Date(this.$attrs.dateRange.end)
      ] : null;
    },
    methods: {
      reload(sortby = undefined, itemsperpage = undefined, page = undefined) {
        if (sortby) this.sortby = sortby;
        if (itemsperpage) this.ipp = itemsperpage;
        if (page) this.page = page;
        router.post(window.location.href, {
          headers: this.headers,
          sortby: this.sortby,
          itemsperpage: this.ipp,
          page: this.page,
          dateRange: (this.dateRange && this.dateRange[0] && this.dateRange[1]) ? {
            start: format(this.dateRange[0], 'yyyy-MM-dd'),
            end: format(this.dateRange[1], 'yyyy-MM-dd')
          } : null
        }, { only: ['visitors', 'visitorsCount'] });
      }
    }
  };
  </script>